import * as yup from 'yup'
import "config/yup/pt-BR/locale_pt-BR.js"

const resetPasswordFormValidation = yup.object().shape({
    password:  yup.string().min(6),
    password_confirmation: yup.string().oneOf([yup.ref('password'), null], 'As senhas devem ser iguais').min(6),
});

export default resetPasswordFormValidation;